<template>
  <div class="login">
    <div class="login-box">
      <div class="top">
        <el-image class="top_img" :src="require('@/assets/images/logo.png')" />
        <div class="top_text">乾效-水吧</div>
      </div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <!-- <h3 class="title">乾效</h3> -->
        <div class="login_title">
          <div
            class="login_title_div pas"
            :class="{ active: titleType === 'PASSWORD' }"
            @click="clickTitleType('PASSWORD')">
            密码登录
          </div>
          <div
            class="login_title_div code"
            :class="{ active: titleType === 'SMS_CODE' }"
            @click="clickTitleType('SMS_CODE')">
            验证码登录
          </div>
        </div>
        <el-form-item prop="shopRegisterNumber">
          <el-input v-model="loginForm.shopRegisterNumber" type="text" auto-complete="off" placeholder="店铺号">
            <i slot="prefix" class="el-icon-house input-icon"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="账号">
            <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password" v-if="titleType === 'PASSWORD'">
          <el-input
            v-model="loginForm.password"
            type="password"
            auto-complete="off"
            placeholder="密码"
            @keyup.enter.native="handleLogin">
            <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
          </el-input>
        </el-form-item>
        <el-form-item prop="code" v-if="titleType === 'PASSWORD'">
          <el-input
            v-model="loginForm.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 63%"
            @keyup.enter.native="handleLogin">
            <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
          </el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </el-form-item>
        <el-form-item prop="smsCode" v-if="titleType === 'SMS_CODE'">
          <el-input
            v-model="loginForm.smsCode"
            auto-complete="off"
            placeholder="手机验证码"
            style="width: 63%"
            @keyup.enter.native="handleLogin">
            <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
          </el-input>
          <div class="login-code">
            <el-button class="code" @click="getPhoneCode" v-if="number == 0">{{ text }}</el-button>
            <el-button class="code" type="info" v-else :disabled="true">{{ text }}</el-button>
          </div>
        </el-form-item>
        <el-checkbox v-model="loginForm.rememberMe" style="margin: 0px 0px 25px 0px">记住密码</el-checkbox>
        <el-form-item style="width: 100%">
          <el-button
            :loading="loading"
            size="medium"
            type="primary"
            style="width: 100%"
            @click.native.prevent="handleLogin">
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
          <div style="float: right" v-if="register">
            <router-link class="link-type" :to="'/register'">立即注册</router-link>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--  底部  -->
    <div class="el-login-footer">
      <span class="link"><a href="https://beian.miit.gov.cn" target=" blank">粤ICP备2024275809号-1</a></span>
    </div>
  </div>
</template>

<script>
import { getCodeImg, cellPhoneVerificationCode, sendCode } from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import { removeToken } from "@/utils/auth";

export default {
  name: "Login",
  data() {
    return {
      titleType: "PASSWORD",
      codeUrl: "",
      loginForm: {
        shopRegisterNumber: "",
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
        type: "PASSWORD",
        // smsCode: '',
      },
      loginRules: {
        // shopRegisterNumber: [
        //   { required: true, trigger: "blur", message: "请输入您的店铺号" },
        // ],
        username: [{ required: true, trigger: "blur", message: "请输入您的账号" }],
        password: [{ required: true, trigger: "blur", message: "请输入您的密码" }],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
        // smsCode: [{ required: false, trigger: "change", message: "请输入手机验证码" }],
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: false,
      redirect: undefined,
      text: "获取验证码",
      number: 0,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.getCode();
    this.getCookie();
    window.localStorage.setItem('item1', JSON.stringify([]))
  },
  methods: {
    clickTitleType(val) {
      this.titleType = val;
      this.loginForm.type = val;
    },
    handleClick(val) {
      console.log("[ val ]-123", val);
    },
    getCode() {
      getCodeImg().then((res) => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
        }
      });
    },
    getPhoneCode() {
      this.number = 60;
      sendCode({ phone: this.loginForm.username, shopRegisterNumber: this.loginForm.shopRegisterNumber })
        .then((res) => {
          if (res.code == 200) {
            let time = setInterval(() => {
              this.number--;
              if (this.number > 0) {
                this.text = "重新获取" + "(" + this.number + ")";
              } else {
                this.text = "重新获取";
                clearInterval(time);
              }
            }, 1000);
          } else {
            this.number = 0;
            this.text = "重新获取";
          }
        })
        .catch(() => {
          this.number = 0;
          this.text = "重新获取";
        });
    },
    getCookie() {
      const username = Cookies.get("username");
      console.log("[ username ]-189", username);
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      const shopRegisterNumber = Cookies.get("shopRegisterNumber");
      this.loginForm = {
        ...this.loginForm,
        shopRegisterNumber: shopRegisterNumber || this.loginForm.shopRegisterNumber,
        username: username || this.loginForm.username,
        password: !password ? this.loginForm.password : decrypt(password),
        rememberMe: !rememberMe ? false : Boolean(rememberMe),
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          Cookies.set("username", this.loginForm.username, { expires: 30 });
          Cookies.set("rememberMe", this.loginForm.rememberMe, {
            expires: 30,
          });
          Cookies.set("shopRegisterNumber", this.loginForm.shopRegisterNumber, {
            expires: 30,
          });
          if (this.loginForm.rememberMe) {
            Cookies.set("password", encrypt(this.loginForm.password), {
              expires: 30,
            });
          } else {
            // Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
            // Cookies.remove("shopRegisterNumber");
          }
          this.titleType === "SMS_CODE" && (this.loginForm.password = "");
          this.$store
            .dispatch("Login", this.loginForm)
            .then(() => {
              console.log("this.$store.state.user.storePhoneCheck===>", this.$store.state.user.storePhoneCheck);
              if (this.$store.state.user.storePhoneCheck == 1) {
                let token = this.$store.state.user.token;
                this.$store.commit("SET_TOKEN", "");
                removeToken();
                // 验证码
                this.verificationCode(token);
              } else {
                // this.$store.dispatch("GetInfo");
                this.$router.push({ path: this.redirect || "/" }).catch(() => {});
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
              if (this.captchaEnabled) {
                this.getCode();
              }
            });
        }
      });
    },
    // 手机验证码弹框
    verificationCode(token) {
      this.$prompt("请输入手机验证码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.getCellPhoneVerificationCode(value, token);
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
          this.loading = false;
        });
    },
    getCellPhoneVerificationCode(code, token) {
      let params = {
        token: token,
        code: code,
      };
      cellPhoneVerificationCode(params).then((res) => {
        console.log("res==>", res);
        if (res.code == 200) {
          this.$store.commit("SET_TOKEN", token);
          this.$router.push({ path: this.redirect || "/" }).catch(() => {});
        } else {
          this.$message(res.msg);
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/assets/styles/element-variables.scss";
.login {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 4%;
  height: 100%;
  background-image: url("../assets/images/login-background.jpg");
  background-size: cover;
  .login-box {
    padding-right: 13%;
  }
  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    .top_img {
      width: 56px;
      height: 56px;
    }
    .top_text {
      font-size: 34px;
      color: #fff;
      margin-left: 15px;
    }
  }
  .login_title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    padding: 10px 0 20px;
    .login_title_div {
      background-color: #fff;
      width: 40%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      // font-family: "幼圆";
    }
    .pas {
      border-radius: 10px 0 0 10px;
    }
    .code {
      border-radius: 0 10px 10px 0;
    }
    .active {
      background-color: $--color-primary;
      color: #fff;
    }
  }
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #414141;
  font-size: 28px;
}

.login-form {
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
  width: 400px;
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.el-login-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
  .link {
    font-size: 20px;
  }
}

.login-code-img {
  height: 38px;
}
</style>
